const KEYS: Record<string, string> = {
  already_running: 'admin.communityCuration.errors.alreadyRunning',
  curation_disabled: 'admin.communityCuration.errors.disabled',
  curator_not_configured: 'admin.communityCuration.errors.curatorMissing',
  not_found: 'admin.communityCuration.errors.notFound',
  invalid_input: 'admin.communityCuration.errors.invalid',
  budget_below_estimate: 'admin.communityCuration.errors.budgetBelowEstimate',
};

type ErrorLike = {
  message?: unknown;
  graphQLErrors?: ReadonlyArray<{ message?: unknown }>;
};

const messageOf = (error: unknown): string => {
  const candidate = error as ErrorLike | null | undefined;
  const graphQLMessage = candidate?.graphQLErrors?.[0]?.message;
  if (typeof graphQLMessage === 'string') return graphQLMessage;
  return typeof candidate?.message === 'string' ? candidate.message : '';
};

// Maps a curation mutation error to a translation key. Raw backend text is
// never shown; `invalid_input:<field>` names the field that was rejected.
export function mapCurationError(error: unknown): { key: string; field?: string } {
  const message = messageOf(error);
  const invalidField = message.match(/^invalid_input:([a-z_]+)$/);
  if (invalidField) {
    return { key: 'admin.communityCuration.errors.invalidField', field: invalidField[1] };
  }
  return { key: KEYS[message] || 'admin.communityCuration.errors.generic' };
}
